import { render, staticRenderFns } from "./DispensationCreateTab.vue?vue&type=template&id=49c7f657&scoped=true&"
import script from "./DispensationCreateTab.vue?vue&type=script&lang=ts&"
export * from "./DispensationCreateTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c7f657",
  null
  
)

export default component.exports